import React, { ReactNode } from 'react';
import { Field, Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import { MonIdentite } from '../../../../../network/api/types/compte/MonIdentite';
import TextInput from '../../../../common/inputs/TextInput';
import Button from '../../../../common/Button';
import { CompteMonidentiteModifyDTO } from '../../../../../network/api/types/compte/CompteMonidentiteModifyDTO';
import compteApi from '../../../../../network/api/compteApi';
import { fetchMyIdentity } from '../../../../../services/user/userService';
import { FieldErrorDTO } from '../../../../../network/api/types/compte/FieldErrorDTO';
import { notifyErrorWithMessage, notifySuccess } from '../../../../common/Notification';
import { ErrorDTO } from '../../../../../network/api/types/compte/ErrorDTO';

type Props = {
  fetchMyIdentity?: () => void
  onClose: () => void
  myIdentity?: MonIdentite
  setDirty: (dirty: boolean, callback?: () => void) => void
  setModalI18n: (title: string, subtitle: string) => void
};

type State = {
};

type FormValues = {
  civilite: string,
  nomUsuel: string,
  languages: Array<string>,
};

class PersonalInformationForm extends React.Component<Props, State> {
  state: State = {
  };

  componentDidMount(): void {
    this.props.setModalI18n('HOME.CONFIRM_MODAL_TITLE', 'PERSONAL_INFORMATION.CONFIRM_CLOSE');
  }

  handleEdit = async (values: FormValues): Promise<{ [FORM_ERROR]: FieldErrorDTO[] }> => {
    try {
      const valeus: CompteMonidentiteModifyDTO = {
        photo: this.props.myIdentity.photo,
        ...values,
      };
      return compteApi.modifyMyIdentity(valeus)
        .then(() => {
          notifySuccess(I18n.t('message.SUCCESS'));
          this.props.fetchMyIdentity();
          this.props.setDirty(false);
          this.props.onClose();
        })
        .catch((err) => {
          if (typeof err.then === 'function') {
            return err.then((e: ErrorDTO) => ({ [FORM_ERROR]: e.fieldErrors }));
          }
          notifyErrorWithMessage(I18n.t('message.ERROR_MODIF'));
          return null;
        });
      // const json = await
    } catch (err) {
      return { [FORM_ERROR]: [] };
    }
  };

  formatCountry = (code: string): string => (
    code[0].concat(
      code.slice(1).toLowerCase(),
    )
  );

  onFormChange = (dirty: boolean): void => {
    this.props.setDirty(dirty);
  };

  render(): ReactNode {
    if (!this.props.myIdentity) {
      return false;
    }
    return (
      <Form
        onSubmit={this.handleEdit}
        initialValues={{
          nomUsuel: this.props.myIdentity?.nomUsuel,
          civilite: this.props.myIdentity?.civilite,
        }}
        validate={() => ({})}
        render={(
          {
            handleSubmit,
            form,
            submitError,
          },
        ) => {
          const getErrorMessage = (fieldName: string): string => {
            if (submitError) {
              return submitError.find((error: FieldErrorDTO) => error.field === fieldName)?.message;
            }
            return '';
          };
          return (
            <form
              className="personal-information-form"
              onSubmit={form.getState().dirty ? handleSubmit : this.props.onClose}
              onChange={() =>
                this.onFormChange(form.getState().dirty)}
            >
              <div className="big-button-radio-container">
                <Field
                  type="radio"
                  name="civilite"
                  value="Monsieur"
                  render={({ input }) => (
                    <label
                      htmlFor="monsieur"
                      className={`big-button-radio${this.props.myIdentity.managedByFicen ? ' read-only' : ''}`}
                    >
                      <input
                        type="radio"
                        name={input.name}
                        id="monsieur"
                        value="Monsieur"
                        checked={input.checked}
                        onChange={input.onChange}
                        disabled={this.props.myIdentity.managedByFicen}
                      />
                      <span className="button-customize" />
                      <Translate value="EMERGENCY_INFORMATION.MONSIEUR" />
                    </label>
                  )}
                />
                <Field
                  type="radio"
                  name="civilite"
                  value="Madame"
                  render={({ input }) => (
                    <label
                      htmlFor="madame"
                      className={`big-button-radio${this.props.myIdentity.managedByFicen ? ' read-only' : ''}`}
                    >
                      <input
                        type="radio"
                        name={input.name}
                        id="madame"
                        value="Madame"
                        checked={input.checked}
                        onChange={input.onChange}
                        disabled={this.props.myIdentity.managedByFicen}
                      />
                      <span className="button-customize" />
                      <Translate value="EMERGENCY_INFORMATION.MADAME" />
                    </label>
                  )}
                />
              </div>
              <Field
                name="nomUsuel"
                component={TextInput}
                placeholder={I18n.t('PERSONAL_INFORMATION.USENAME')}
                type="text"
                readOnly={this.props.myIdentity.managedByFicen}
                customError={getErrorMessage('nomUsuel')}
              />
              <div className="birth-recap">
                <div className="birth-info-row">
                  <div className="birth-info">
                    <div className="subtitle">
                      <Translate value="PERSONAL_INFORMATION.BIRTH_DATE" />
                    </div>
                    {`${this.props.myIdentity?.jourDeNaissance}/${this.props.myIdentity?.moisDeNaissance}/${this.props.myIdentity?.anneeDeNaissance}`}
                  </div>
                  <div className="birth-info">
                    <div className="subtitle">
                      <Translate value="PERSONAL_INFORMATION.BIRTH_VILLE" />
                    </div>
                    {this.props.myIdentity?.communeDeNaissance}
                  </div>
                </div>
                <div className="birth-info-row">
                  <div className="birth-info">
                    <div className="subtitle">
                      <Translate value="PERSONAL_INFORMATION.BIRTH_COUNTRY" />
                    </div>
                    {this.formatCountry(this.props.myIdentity?.paysDeNaissance?.nom || 'Pays de naissance')}
                  </div>
                  <div className="birth-info">
                    <div className="subtitle">
                      <Translate value="PERSONAL_INFORMATION.BIRTH_NAME" />
                    </div>
                    {this.props.myIdentity?.nomDeNaissance}
                  </div>
                </div>
              </div>
              {this.props.myIdentity?.managedByFicen ? (
                <div className="button-container">
                  <Button
                    type="third"
                    onClick={this.props.onClose}
                    i18nKey="actions.CLOSE"
                  />
                </div>
              ) : (
                <div className="button-container">
                  <Button
                    type="third"
                    onClick={this.props.onClose}
                    i18nKey="actions.CANCEL"
                  />
                  <Button
                    type="primary"
                    buttonType="submit"
                    i18nKey="actions.SAVE"
                  />
                </div>
                )}
            </form>
          );
        }}
      />
    );
  }
}

export default connect(() => ({
}), { fetchMyIdentity })(PersonalInformationForm);
